import * as React from "react";
import type { SVGProps } from "react";
const SvgPenThin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    fill="none"
    viewBox="0 0 21 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m5.16 13.017 8.606-8.605a.833.833 0 0 1 1.177 0l1.397 1.396a.833.833 0 0 1 0 1.178L7.734 15.59a.83.83 0 0 1-.588.244h-2.23v-2.229a.83.83 0 0 1 .245-.588"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m12.208 5.965 2.575 2.575"
    />
  </svg>
);
export default SvgPenThin;
